import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ element: Component, ...rest }) => {
  const dealerLogin = useSelector((state) => state.dealerLogin);
  const { dealerInfo } = dealerLogin;
  return dealerInfo ? Component : <Navigate to="/login" />;
};

export default PrivateRoute;
